import React from 'react';

/**
 * Simple spinner component for loading states
 */
const Spinner = ({ className = '' }) => {
  return (
    <span
      className={`inline-block h-4 w-4 animate-spin rounded-full border-2 border-brand-gold border-t-transparent align-[-2px] ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
};

export default Spinner;
